<template>
    <div :class="classList">
        <div class="checklist-cell-image">
            <ChecklistIcon />
        </div>
        <div class="checklist-cell-data">
            <span class="checklist-cell-title">{{ title }}</span>
        </div>
    </div>
</template>
<script>

import ChecklistIcon from '@/Icons/ChecklistIcon'

export default {
    components: {
        ChecklistIcon,
    },
    props: {
        extra: {
            type: Object,
            default: {}
        },
        value: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        return {
            ...this.value,
            ...this.extra
        }
    },
    computed: {
        classList() {
            const list = ['checklist-cell']

            if(this.statuses.length === 0) {
                list.push('checklist-inactive')
            }

            return  list.join(' ')
        }
    }
}
</script>
<style scoped>

    .checklist-cell {
        display: flex;
        align-items: center;
    }

    .checklist-cell.priority {
        color: var(--default-primary);
    }

    .checklist-cell-image {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        margin-right: 20px;
        border-radius: 50%;
        background-color: var(--default-secondary);
    }

    .checklist-inactive .checklist-cell-image {
        background-color: rgba(var(--default-contrast-rgb), 0.33);
    }

    .checklist-cell svg {
        height: 55%;
        color: var(--default-white);
    }

    .checklist-cell span {
    }

    .checklist-cell-data {
        display: flex;
        flex-direction: column;
    }

    .checklist-cell-title {
        font-weight: 900;
    }

    .checklist-cell-meta {
        display: flex;
        align-items: center;
        margin-bottom: .5em;
        font-size: 9px;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0.125em;
    }

    .checklist-cell-meta svg {
        width: 1.5em;
        color: inherit;
        margin-right: .5em;
    }

</style>
